
import * as athenaPopups from '../utils/athenaPopups';
import { createCustomEvent, getFullUrlPath } from '../utils/common';
import { dispatchAlert } from '../utils/site-utils';

export const AutoRefreshLoginCheckin = function(url, username, autoUM, autoLoginCheckin) {
	$.ajax({
		type: 'POST',
		url: getFullUrlPath(url),
		data: { username },
		success: data => {
			if (data) {
				const { alertMsg, redirectURL, stopLoginCheckin, UMInfo } = JSON.parse(data);
				
				if(stopLoginCheckin){
					StopLoginCheckin(autoUM, autoLoginCheckin);
				}
				if (redirectURL) {
					athenaPopups.closeAll();
					const r = redirectURL.toLowerCase().startsWith('http') || redirectURL.toLowerCase().startsWith('//') 
						? redirectURL 
						: getFullUrlPath(redirectURL.replace(/^\//gm,''));
					const url = new URL(r);
					alertMsg && url.searchParams.set('alertMsg', alertMsg);
					window.location.href = url.toString();
				}
				if (UMInfo) {
					const UMPopup = document.getElementById('UMPopup');
					UMPopup && UMPopup.dispatchEvent(createCustomEvent('um-time', UMInfo));
				}
			}
		}
	});
};

export const StopLoginCheckin = function(autoUM, autoLoginCheckin) {
	clearInterval(autoUM);
	clearInterval(autoLoginCheckin);
};


export const AutoCheckUM = function() {
	$.ajax({
		url: getFullUrlPath('getUMControl.ashx'),
		dataType: 'text',
		success: function(isUM) {
			if (isUM === 'true') {
				window.location = 'newindex';
			}
		}
	});
};

export const checkWindowInfo = function() {
	if (window.top !== window.self) {
		dispatchAlert('Unauthorized Site (Situs Palsu)');
		window.top.location.href = document.URL;
	}
};

export const setBodyCss = function(tableName, UserLang) {
	document.body.className = '';
	document.body.className = tableName + ' ' + UserLang;
};
